import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './Blog.css';

const Blog = () => {
  const navigate = useNavigate();

  const dummyPosts = [
    {
      id: 1,
      title: "Understanding Database Normalization: From 0NF to 3NF with Practical Examples",
      excerpt: "Understanding How Database Normalization Transforms Raw Data into Structured, Efficient Tables.",
      date: "2025-06-24",
      readTime: "4 min read",
      tags: ["Database", "Backend"],
      url: "https://medium.com/@abdullatifsadiq21/understanding-database-normalization-from-0nf-to-3nf-with-practical-examples-8fb3b353eba6"
    },

  ];

  const handleReadMore = (url) => {
    window.open(url, '_blank');
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="blog-page section">
      <div className="container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="section__header" variants={itemVariants}>
            <h2 className="section__title">Blog</h2>
            <div className="blog__intro">
              <p className="blog__intro-text">
                I write about software engineering, database design, and the lessons learned building applications.
                These are thoughts and insights from my journey as a developer, hoping they might spark ideas or
                help others navigate similar challenges.
              </p>
              <p className="blog__post-count">1 published post</p>
            </div>
          </motion.div>

          <motion.div className="blog__content" variants={itemVariants}>
            <div className="blog__posts-list">
              {dummyPosts.map((post) => (
                <motion.article
                  key={post.id}
                  className="blog__post-item"
                  variants={itemVariants}
                  whileHover={{ x: 5, transition: { duration: 0.2 } }}
                  onClick={() => handleReadMore(post.url)}
                >
                  <div className="blog__post-meta">
                    <span className="blog__post-date">{post.date}</span>
                    <div className="blog__post-tags">
                      {post.tags.map((tag, index) => (
                        <span key={index} className="blog__post-tag">{tag.toLowerCase()}</span>
                      ))}
                    </div>
                  </div>
                  <h3 className="blog__post-title">{post.title}</h3>
                </motion.article>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Blog;